import * as React from "react";
import { CheckboxGroup } from "../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { AdviserDeclaractionText } from "../../ConvertCappedToFlexiWizard/Resource/Content";

interface IAdviserDeclarationProps extends IProcessComponentProps {}

interface IAdviserDeclarationState {
    isChecked: boolean;
}

export class AdviserDeclaration extends ProcessComponent<IAdviserDeclarationProps, IAdviserDeclarationState> {
    constructor(props: any) {
        super(props);

        if (this.props.isReview) {
            this.state = { isChecked: true };
        } else {
            this.state = { isChecked: false };
        }
    }

    public render(): JSX.Element {
        const { data } = this.props;
        return (
            <>
                <h2>Adviser Declaration</h2>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label:
                                AdviserDeclaractionText.messagePart1 +
                                data.CompanyName +
                                AdviserDeclaractionText.messagePart2,
                            value: this.state.isChecked,
                            required: "Please confirm the declaration to continue",
                            onChange: (v) => {
                                this.setState({ isChecked: v });
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
